/**
 * The single admin gate for support / diagnostic affordances on the web app
 * (ghost-mode impersonation on the Profile screen, the pricing country
 * override). One place to change the allowlist.
 *
 * This is a client-side convenience gate, not a security boundary: everything
 * it unlocks only changes what the signed-in admin's own browser shows.
 */
import { auth } from "./config";

export const ADMIN_EMAILS = ["smaddi@learnzapp.com"];

export const isAdminEmail = (email) =>
  !!email && ADMIN_EMAILS.includes(String(email).trim().toLowerCase());

export const isAdminSignedIn = () => {
  try {
    return isAdminEmail(auth().currentUser?.email);
  } catch (e) {
    return false;
  }
};
